module.exports = __webpack_public_path__ + "static/media/Walker_1_Logo.d8f758a5.jpg";